import { render, staticRenderFns } from "./Oauth2_Login.vue?vue&type=template&id=2abc8ccc&scoped=true&"
import script from "./Oauth2_Login.vue?vue&type=script&lang=js&"
export * from "./Oauth2_Login.vue?vue&type=script&lang=js&"
import style0 from "./Oauth2_Login.vue?vue&type=style&index=0&id=2abc8ccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc8ccc",
  null
  
)

export default component.exports